import { render, staticRenderFns } from "./postMortemBetweenTwoDates.vue?vue&type=template&id=788823b0&scoped=true&"
import script from "./postMortemBetweenTwoDates.vue?vue&type=script&lang=js&"
export * from "./postMortemBetweenTwoDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788823b0",
  null
  
)

export default component.exports